export default __webpack_public_path__ + "static/5-3b7326e01b97cb9a14f4f49a7a84c1a3.png";